import React from 'react'
import { useEffect, useState } from 'react';
import axios from 'axios';
import AuthUser from './AuthUser';
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from 'react-router-dom';

export default function Stocks_add() {
    const navigate = useNavigate();
    const { http, user } = AuthUser();
    const [users, setUsers] = useState([]);
    const [masterdata, setmasterdata] = useState([]);
    const [masterdataIndi, setMasterdataIndi] = useState([]);
    const [cat, setCat] = useState([]);
    const [formData, setFormData] = useState({
        type: '',
        assigned_by: user.id,
        type: '',
        jc: '',
        master_id: '',
        brand: '',
        qty: '',
        detail: '',
        customer: '',
        purpose: '',
        priority: '',
        required_on: '',
        plant: '',
        status: 'PENDING',
        final_status: 'OPEN',
        ext1: '',
        ext2: "",
    });

    const initialState = {
        type: '',
        assigned_by: user.id,
        type: '',
        jc: '',
        master_id: '',
        brand: '',
        qty: '',
        detail: '',
        customer: '',
        purpose: '',
        priority: '',
        required_on: '',
        plant: '',
        status: 'PENDING',
        final_status: 'OPEN',
        ext1: '',
        ext2: "",
    }

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });

        if (e.target.name === 'category') {
            fetchUsersForDepartment(e.target.value);
        }

        if (e.target.name === 'master_id') {
            fetchMasterIndividual(e.target.value)
        }
    };

    const fetchUsersForDepartment = async (departmentId) => {
        try {
            const response = await http.get(`/master_cat?cat=${departmentId}`);
            setmasterdata(response.data.users);
        } catch (error) {
            console.error("Error fetching users:", error);
        }

    }

    const fetchMasterIndividual = async (msterId) => {
        try {
            const response = await http.get(`/master_cat_indi?cat=${msterId}`);
            setMasterdataIndi(response.data.users);
        } catch (error) {
            console.error("Error fetching users:", error);
        }

    }

    useEffect(() => {
        http.get(`/department_user_company?&login_user=${user.id}`).then((res) => {
            setUsers(res.data.users);
        })

        http.get(`/category`).then((res) => {
            setCat(res.data.data);
        })

    }, [])

    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = new FormData();

        for (const key in formData) {
            form.append(key, formData[key]);
        }

        const taskFileInput = document.querySelector('input[type="file"]');
        if (taskFileInput.files[0])
            form.append("ext2", taskFileInput.files[0]);

        for (const key in formData) {
            form.append(key, formData[key]);
        }
        try {
            http.post('/stoke_add_job', form, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },

            }).then((res) => {
                toast.success("Stocks added successfully !");
                setFormData(initialState);
                navigate('/jobcart/stocks');
            })

        } catch (error) {
            console.error('Error adding company:', error.response.data);
        }
    };

    const DropdownOption = ({ user }) => {
        return (
            <option key={user.id} value={user.id}>
                {user.item_name}
            </option>
        );
    };

    return (
        <>

            <div className="container mt-5">
                <Toaster />
                <h3>Add Stocks</h3>
                <form onSubmit={handleSubmit}>
                    <div className='form-group mt-3'>
                        <label>Type</label>
                        <select name='type' className='form-control' value={formData.type} onChange={handleChange} required>
                            <option value="">Select Any</option>
                            <option value="PURCHASE">PURCHASE</option>
                            <option value="STORES">STORES</option>
                        </select>
                    </div>

                    <div className='form-group mt-3'>
                        <label>Job Card Number</label>
                        <input
                            name="jc"
                            className='form-control'
                            value={formData.jc}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className='form-group mt-3'>
                        <label>Category</label>
                        <select name="category" className='form-control' value={formData.category} onChange={handleChange} required>
                            <option value="">Select Any</option>
                            {cat.map(user => (
                                <option key={user.id} value={user.id}>{user.name}</option>
                            ))}
                        </select>

                    </div>

                    <div className='form-group mt-3'>
                        <label>Stocks</label>
                        <select
                            disabled={!masterdata.length}
                            name="master_id"
                            className='form-control text-uppercase'
                            onChange={handleChange}
                            value={formData.master_id}
                            required
                        >
                            <option value="">Select Stocks</option>
                            {masterdata.map(user => (
                                <DropdownOption key={user.id} user={user} />
                            ))}
                        </select>
                        {masterdataIndi.length > 0 && (
                            <div>
                                <label className='badge bg-success mx-2'>MRP: {masterdataIndi[0].mrp}</label>
                                {/* <label className='badge bg-secondary mt-2 mx-2'>Supplier: {masterdataIndi[0].suplier}</label>
                                <label className='badge bg-secondary  '>Vendor: {masterdataIndi[0].vendor}</label> */}
                            </div>
                        )}
                    </div>

                    <div className='form-group mt-3'>
                        <label>Brand/Others</label>
                        <input
                            name="brand"
                            className='form-control'
                            onChange={handleChange}

                        />
                    </div>

                    <div className='form-group mt-3'>
                        <label>Quantity</label>
                        <input
                            name="qty"
                            className='form-control'
                            onChange={handleChange}
                            required
                        />
                    </div>


                    <div className='form-group mt-3'>
                        <label>Customer</label>
                        <input
                            name="customer"
                            className='form-control'
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className='form-group mt-3'>
                        <label>Purpose</label>
                        <select name="purpose" className='form-control' value={formData.purpose} onChange={handleChange} required>
                            <option value="">Select Any</option>
                            <option value="Normal">For Stock</option>
                            <option value="For Client">For Client</option>
                            <option value="For MSL">For MSL</option>
                            <option value="For Work">For Work</option>
                        </select>
                    </div>

                    <div className='form-group mt-3'>
                        <label>Priority</label>
                        <select name="priority" className='form-control' value={formData.priority} onChange={handleChange} required>
                            <option value="">Select Any</option>
                            <option value="Normal">Normal</option>
                            <option value="Urgent">Urgent</option>
                            <option value="Most urgent">Most urgent</option>
                        </select>
                    </div>

                    <div className='form-group mt-3'>
                        <label>Requred on</label>
                        <input
                            type='date'
                            name="required_on"
                            className='form-control'
                            onChange={handleChange}
                        />
                    </div>

                    <div className='form-group mt-3'>
                        <label>Plant</label>
                        <input
                            name="plant"
                            className='form-control'
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="form-group mt-3">
                        <label>Purchase File</label>
                        <input type="file" className="form-control" />
                    </div>
                    <button className='btn button btn-success mt-3' type="submit">Add</button>
                </form>
            </div>
        </>
    )
}
